<template>
  <div class="page">
    <div class="box">
      <div class="title" style="font-size:18px; margin-bottom:5px;">请点击选择以下套餐</div>
      <div class="sub-title">（仅限选1个，点击图片即可选中）</div>

      <div class="package-wrap">
        <div class="pkg-card" v-for="p in packages" :key="p.id"
          :class="{ active: selected === p.id, disabled: p.soldOut }"
          @click="onPkgClick(p)">
          <span class="pkg-label">{{ p.name }}</span>
          <span class="selected-tag" v-if="selected === p.id">选中</span>
          <span class="soldout-tag" v-if="p.soldOut">已满</span>
          <span class="quota-tag" v-else-if="p.quota > 0">剩 {{ p.remaining }}</span>
          <img :src="p.imagePath" :alt="p.name">
        </div>
      </div>
      <div class="notice">
        <div class="notice-title">📢 发货公告</div>
        <div class="notice-body">
          所有订单按照下单时间依次发出，仓库会加班加点尽快发出小主们的货，请稍安勿躁耐心等待。更多详情请拨打 <a href="tel:18217015216">18217015216</a>
        </div>
      </div>

      <button @click="goFillInfo">已选好，填写收货地址</button>
    </div>

    <teleport to="body">
      <div v-if="previewImg" class="preview-overlay" @click="previewImg = null">
        <img :src="previewImg" class="preview-img">
      </div>
    </teleport>

    <Modal :visible="modal.visible" :title="modal.title" @close="onModalClose">
      <p>{{ modal.msg }}</p>
      <template #footer>
        <button class="modal-btn" @click="onModalClose">确定</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { api } from '@/utils/api';
import { getSite } from '@/utils/theme';

export default {
  name: 'PackageSelectPage',
  components: { Modal },
  data() {
    return {
      selected: '',
      selectedName: '',
      selectedImg: '',
      card: '',
      previewImg: null,
      packages: [],
      modal: { visible: false, title: '', msg: '', onOk: null }
    };
  },
  async created() {
    const card = sessionStorage.getItem('card');
    if (!card) {
      this.showModal('提示', '请先验证卡密', () => this.$router.replace('/verify'));
      return;
    }
    this.card = card;
    await this.fetchPackages();
  },
  methods: {
    showModal(title, msg, onOk) {
      this.modal = { visible: true, title, msg, onOk: onOk || null };
    },
    onModalClose() {
      this.modal.visible = false;
      if (this.modal.onOk) this.modal.onOk();
    },
    async fetchPackages() {
      try {
        const data = await api.get('/api/site/assets?type=package&site=' + getSite());
        if (data.code === 200 && data.data && data.data.length > 0) {
          this.packages = data.data;
        } else {
          this.showModal('提示', '暂无可用套餐，请联系管理员');
        }
      } catch {
        this.showModal('提示', '加载套餐失败，请检查网络');
      }
    },
    onPkgClick(pkg) {
      if (pkg.soldOut) {
        this.showModal('提示', '该套餐名额已满，请选择其他套餐');
        return;
      }
      this.selected = pkg.id;
      this.selectedName = pkg.name;
      this.selectedImg = pkg.imagePath;
      this.previewImg = pkg.imagePath;
    },
    goFillInfo() {
      if (!this.selected) {
        this.showModal('提示', '请先点击图片选择一个套餐哦~');
        return;
      }
      const pkg = this.packages.find(p => p.id === this.selected);
      if (pkg && pkg.soldOut) {
        this.showModal('提示', '该套餐名额已满，请选择其他套餐');
        return;
      }
      sessionStorage.setItem('pkg', this.selectedName);
      sessionStorage.setItem('pkgImg', this.selectedImg);
      this.$router.push('/ship');
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  padding: 20px 15px;
}
.box {
  max-width: 420px;
  margin: 0 auto;
  background: #fff;
  padding: 25px 20px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  border-top: 5px solid var(--color-primary);
}
.title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
  letter-spacing: 1px;
}
.sub-title {
  font-size: 13px;
  color: var(--color-primary);
  margin-bottom: 5px;
  text-align: center;
}
.package-wrap {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin: 20px 0;
}
.pkg-card {
  background: #fff;
  border: 3px solid #f0f0f0;
  border-radius: 10px;
  padding: 5px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}
.pkg-card:hover {
  border-color: var(--color-primary-pale);
}
.pkg-card.active {
  border-color: var(--color-primary);
  background: var(--color-primary-bg);
}
.pkg-card.disabled {
  opacity: 0.55;
  cursor: not-allowed;
  filter: grayscale(0.4);
}
.pkg-card.disabled:hover {
  border-color: #f0f0f0;
}
.pkg-label {
  position: absolute;
  top: 0;
  left: 0;
  background: var(--color-primary);
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 6px;
  font-weight: bold;
  z-index: 1;
}
.selected-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: var(--color-primary);
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-bottom-left-radius: 8px;
  border-top-right-radius: 6px;
  font-weight: bold;
  z-index: 1;
}
.soldout-tag {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(231, 76, 60, 0.92);
  color: #fff;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: bold;
  z-index: 1;
}
.quota-tag {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(var(--color-primary-rgb), 0.92);
  color: #fff;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: bold;
  z-index: 1;
}
.pkg-card img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 6px;
}
.preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.9);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, var(--color-primary-light), var(--color-primary));
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  margin-top: 15px;
  cursor: pointer;
  box-shadow: 0 4px 15px var(--color-primary-shadow);
  transition: all 0.2s ease;
}
button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--color-primary-shadow-hover);
}
.notice {
  background: var(--color-primary-bg2);
  border: 1px solid var(--color-primary-border);
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 18px;
}
.notice-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-primary);
  margin-bottom: 6px;
}
.notice-body {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
}
.notice-body a {
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;
}
.modal-btn {
  width: auto;
  padding: 10px 32px;
  margin-top: 0;
}
</style>
